import { Game } from "./game";
import { Puzzle } from "./types";
import { doneSet } from "./storage";

// One bundle drives every page; dispatch by what's in the DOM.
//   #swsgame  -> a playable / walkthrough board (data-mode = play | stuck)
//   .puzzle-grid -> the /play picker (mark finished puzzles)
//   #code-form   -> the /stuck code-entry form

function initGame(mount: HTMLElement): void {
  const dataEl = document.getElementById("puzzle-data");
  if (!dataEl || !dataEl.textContent) return;
  let puzzle: Puzzle;
  try {
    puzzle = JSON.parse(dataEl.textContent) as Puzzle;
  } catch {
    return;
  }
  const mode = mount.dataset.mode === "stuck" ? "stuck" : "play";
  new Game(mount, puzzle, mode);
}

function initPicker(): void {
  const done = doneSet();
  document.querySelectorAll<HTMLElement>(".puzzle-chip").forEach((el) => {
    if (done.has(Number(el.dataset.puzzle))) el.classList.add("done");
  });
}

function initCodeForm(form: HTMLFormElement): void {
  const input = form.querySelector<HTMLInputElement>("#code-input");
  const note = document.getElementById("code-note");
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const code = (input?.value || "").trim().toLowerCase();
    if (!/^[0-9a-f]{7,8}$/.test(code)) {
      if (note) {
        note.hidden = false;
        note.textContent = "That doesn't look like a puzzle code — it's 7 or 8 characters, letters a–f and digits.";
      }
      return;
    }
    window.location.href = `/stuck/${code}/`;
  });
}

function main(): void {
  const mount = document.getElementById("swsgame");
  if (mount) {
    initGame(mount);
    return;
  }
  if (document.querySelector(".puzzle-grid")) initPicker();
  const form = document.getElementById("code-form");
  if (form instanceof HTMLFormElement) initCodeForm(form);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", main);
else main();
